import PageSelectionHeader from './PageSelectionHeader';

export default PageSelectionHeader;
